import {takeEvery} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeEvery(ACTION.GENERATE_TOKEN.REQUEST, saga.generateToken);
    yield takeEvery(ACTION.GENERATE_TOKEN.SUCCESS, saga.onGenerateTokenSuccess);
    yield takeEvery(ACTION.GENERATE_TOKEN.FAILED, saga.onGenerateTokenFailed);
}